//src/app/features/conversations/Hooks/useConversationsList.tsx
import { useContext } from 'react';
import { ConversationsListContext } from '../ConversationsListProvider';

export const useConversationsList = () => useContext(ConversationsListContext);
